import { createContext, useContext } from 'react';

export const BillingAccessContext = createContext({ mode: 'normal', reason: null, grace_until: null });

export function useBillingAccess() {
  return useContext(BillingAccessContext);
}

export function effectiveBillingAccess(access, now = Date.now()) {
  const value = access || {};
  const paidDeadline = new Date(value.valid_until || '').getTime();
  if (value.scope === 'software' && Number.isFinite(paidDeadline) && now >= paidDeadline) {
    return { ...value, mode: 'restricted', read_only: true, reason: 'software_period_ended' };
  }
  const deadline = new Date(value.grace_until || '').getTime();
  if (value.mode === 'grace' && Number.isFinite(deadline) && now >= deadline) {
    return { ...value, mode: 'restricted' };
  }
  return value.mode ? value : { mode: 'normal', reason: null, grace_until: null };
}
